import type { ComponentProps } from "react";

import { forwardRef } from "react";

const IconChevronUpDown = forwardRef<SVGSVGElement, ComponentProps<"svg">>(
  (props, ref) => {
    return (
      <svg
        ref={ref}
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M6.66667 13.3333L10 16.6667L13.3333 13.3333M6.66667 6.66667L10 3.33334L13.3333 6.66667"
          stroke="currentColor"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
);
IconChevronUpDown.displayName = "IconChevronUpDown";

export { IconChevronUpDown };
